export default __webpack_public_path__ + "static/media/1048.79bce211.png";